import * as client from '../../services/client';
import { TYPES, PATHS } from '../../common/constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { stopPRLoading, startPRLoading, startFormLoading, stopFormLoading } from './loader';
import { setValidation } from './validation';


const fetchAnnouncementsDone = payload => ({
    type: TYPES.FETCH_ANNOUNCEMENTS_DONE,
    payload,
});
const saveAnnouncementDone = payload => ({
    type: TYPES.SAVE_ANNOUNCEMENTS_DONE,
    payload,
});

const deleteAnnouncementDone = payload => ({
    type: TYPES.DELETE_ANNOUNCEMENTS_DONE,
    payload,
});
export const clearAnnouncementsDone = () => ({
  type: TYPES.CLEAR_ANNOUNCEMENTS_DONE
});
export const fetchAnnouncements = (userId,role) => dispatch => {
  dispatch(startPRLoading())
  return client.getAnnouncements(userId,role)
      .then(
        response => {
          dispatch(stopPRLoading())
          if (response.ok || response.status === 200) {
            response.json().then(
              (responsejson) => {
                if(responsejson.statusCode === 200) {
                  dispatch(fetchAnnouncementsDone(responsejson.data))
                  dispatch(stopPRLoading())
                } else {
                  dispatch(stopPRLoading())
                }
              }
            )
          } else {
            dispatch(stopPRLoading())
          }
        }).catch(() => {
          dispatch(stopPRLoading())
        })
  };
  export const fetchLatestAnnouncements = (suiteId) => dispatch => {
    dispatch(startPRLoading())
    return client.getLatestAnnouncements(suiteId)
      .then(
        response => {
           if (response.ok || response.status === 200) {
            response.json().then(
              (responsejson) => {  
                 dispatch(fetchAnnouncementsDone(responsejson))
                  dispatch(stopPRLoading())
                 }
            )
          } else {
            dispatch(stopPRLoading())
          }
        }
      );
  };


  export const saveAnnouncement = (params) => dispatch => {
    dispatch(startFormLoading())
    return client.saveAnnouncement(params)
      .then(
        response => {
          if (response.ok || response.status === 200) {
            response.json().then(
              (responsejson) => {
                if(responsejson.statusCode === 200) {
                    dispatch(setValidation('Success'))
                 dispatch(saveAnnouncementDone(responsejson.data))
                 toast.success('ⓘ Announcement has been added.',{autoClose:10000,position:'top-center'})
                  dispatch(stopFormLoading())
                } else {
                  dispatch(stopFormLoading())
                  toast.error(' 🚫 Something went wrong with adding a announcement, please try again.',{autoClose:12000,position:'top-center'})
                }
              }
            )
          } else {
            toast.error(' 🚫 Something went wrong with adding a announcement, please try again.',{autoClose:12000,position:'top-center'})
            dispatch(stopFormLoading())
          }
        }
     );
  };

  export const deleteAnnouncement = (id) => dispatch => {
    // dispatch(startFormLoading())
    return client.deleteAnnouncement(id)
      .then(
        response => {
          if (response.ok || response.status === 200) {
            response.json().then(
              (responsejson) => {
                if(responsejson.statusCode === 200) {
                 dispatch(deleteAnnouncementDone(id))
                 toast.success('ⓘ Announcement has been deleted .',{autoClose:10000,position:'top-center'})
                  dispatch(stopFormLoading())
                } else {
                  dispatch(stopFormLoading())
                  toast.error(' 🚫 Something went wrong with deleting a announcement, please try again.',{autoClose:12000,position:'top-center'})
                }
              }
            )
          } else {
            toast.error(' 🚫 Something went wrong with deleting a announcement, please try again.',{autoClose:12000,position:'top-center'})
            dispatch(stopFormLoading())
          }
        }
     );
  };